import React from 'react';
import {Link, withRouter} from "react-router-dom";
import { connect } from "react-redux";
import style from './FilterBar.module.scss';
import { Row, Col, Form } from "react-bootstrap";
import logo from '../../../../asset/images/icon/logo.svg';
import Select from "react-select";
import {reactSelectStyle} from "../../../../helper/reactSelect";
import * as generalActions from "../../../../redux/action/general.action";
import * as regionActions from "../../../../redux/action/region.action";
import * as propertyActions from "../../../../redux/action/property.action";

class FilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedRegions: [],
      regions: []
    }
  };

  async componentDidMount() {
    await this.fetchRegionsByState();
    const filteredRegions = this.props.filter.region.split(',');
    this.setState({ selectedRegions: filteredRegions });
  }

  async fetchRegionsByState(state) {
    const response = await this.props.findRegionByState(state);
    await this.setState({regions: response.map((item) => {
        return { value: item.id, label: item.title }
      })
    });
  }

  render() {
    const { selectedRegions } = this.state;

    return (
      <Row className={`m-0 no-gutters ${style.filter_bar}`}>
        <Col xs={'auto'} className={'d-flex align-items-center pr-2'}>
          <button type="button" className={`btn btn-primary btn-sm ${style.search_button} d-flex align-items-center justify-content-between`} onClick={() => {
            this.props.setFilterBar(!this.props.filterBar);
          }}>
            <span>جستجوی پیشرفته</span>
            <i className={'icon-setting'} />
          </button>
        </Col>
        {/* --------------------------- Search -------------------------------------- */}
        <Col className={`mb-lg-0 order-3 order-sm-3 order-lg-1 ${style.filter_search}`}>
          <Form>
            <div className={`d-flex flex-row-reverse align-items-center position-relative ${style.region_input_container}`}>
              <div className={`d-flex align-items-center justify-content-end pr-2 ${style.region_input}`}>
                <i className={`icon-search ${style.search_icon} ml-2`}  onClick={() => { this.redirect() }}/>
                <Select
                    placeholder="نام محله"
                    className="react-select"
                    closeMenuOnSelect={true}
                    styles={reactSelectStyle}
                    isMulti={true}
                    isRtl={true}
                    isClearable={false}
                    onChange={(newValue) => {
                      this.setState({selectedRegions: newValue ? newValue.map((v) => v.value) : []}, () => {
                        this.props.setRegion(newValue ? newValue.map((v) => v.value).join(',') : '');
                      });
                    }}
                    value={this.state.regions ? this.state.regions.filter((opt) => selectedRegions.find((state) => state === opt.value)) : ''}
                    options={this.state.regions}
                />
                <span className={`${style.state} pl-3 pr-2`}>تهران</span>
              </div>
            </div>
          </Form>
        </Col>

        <Col xs={'auto'} className={`mb-1 mb-lg-0 order-3 flex-row-reverse justify-content-center justify-content-md-end align-items-center ${style.filter_buttons}`}>
          <Link to="/">
            <img src={logo} alt="Home Pelak" width={"112"} height={"35"} />
          </Link>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
  filterBar: state.general.filterBar,
  filter: state.property.filter
});

const mapDispatchToProps = (dispatch) => ({
  setFilterBar: (show) => dispatch(generalActions.setFilterBar(show)),
  findRegionByState: (state) => dispatch(regionActions.findRegionByState(state)),
  setRegion: (region) => dispatch(propertyActions.setRegion(region)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FilterBar));
